import { render, staticRenderFns } from "./AirportTransferSidebarContent.vue?vue&type=template&id=3683735a&"
import script from "./AirportTransferSidebarContent.vue?vue&type=script&lang=js&"
export * from "./AirportTransferSidebarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports